// extracted by mini-css-extract-plugin
module.exports = {"user-file-uploader":"user-file-uploader__1X8rO","droppable":"droppable__3MeQ8","text":"text__4A6CM","or":"or__3Nk_n","manual-upload-button":"manual-upload-button__3CZn6"};